import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4ef80edb&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef80edb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-producerPlatform-fe/treasurenet-tnservices-producerPlatform-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ef80edb')) {
      api.createRecord('4ef80edb', component.options)
    } else {
      api.reload('4ef80edb', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4ef80edb&scoped=true", function () {
      api.rerender('4ef80edb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/authentication/businessKYC/index.vue"
export default component.exports